module.exports = __webpack_public_path__ + "img/우리의 중요 사역.b3065356.jpg";